export default {"src":"/pro/_next/static/media/vertex-brand-icon.5a6f7b93.svg","height":12,"width":15,"blurWidth":0,"blurHeight":0};